export default __webpack_public_path__ + "static/media/anniversarymob5.cc94c257.webp";